import { fetchAuthSession } from 'aws-amplify/auth'

const API_BASE =
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.DEV ? 'http://localhost:18080' : window.location.origin)

export { API_BASE }

export async function apiCall(
  method: string,
  endpoint: string,
  body?: unknown
): Promise<Response> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }

  try {
    const session = await fetchAuthSession()
    const token = session.tokens?.idToken?.toString()
    if (token) {
      headers['Authorization'] = `Bearer ${token}`
    }
  } catch {
    // No auth session available
  }

  const opts: RequestInit = { method, headers }
  if (body && method !== 'GET') {
    opts.body = typeof body === 'string' ? body : JSON.stringify(body)
  }

  const resp = await fetch(API_BASE + endpoint, opts)
  if (resp.status === 401) {
    window.dispatchEvent(new Event('auth-logout'))
    throw new Error('Authentication required')
  }
  return resp
}

export async function apiUpload(
  endpoint: string,
  file: File
): Promise<Response> {
  const headers: Record<string, string> = {}

  try {
    const session = await fetchAuthSession()
    const token = session.tokens?.idToken?.toString()
    if (token) {
      headers['Authorization'] = `Bearer ${token}`
    }
  } catch {
    // No auth session available
  }

  const formData = new FormData()
  formData.append('file', file)

  const resp = await fetch(API_BASE + endpoint, {
    method: 'POST',
    headers,
    body: formData,
  })
  if (resp.status === 401) {
    window.dispatchEvent(new Event('auth-logout'))
    throw new Error('Authentication required')
  }
  return resp
}
